import React from 'react';
import { LayersControl, TileLayer } from 'react-leaflet';

export const OSM_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';

/** Allow overzoom past native tile depth so small field contours stay sharp. */
const DETAIL_MAX_ZOOM = 22;

export const MapBaseLayers: React.FC<{ maxZoom?: number }> = ({
  maxZoom = DETAIL_MAX_ZOOM,
}) => (
  <LayersControl position="topright">
    <LayersControl.BaseLayer checked name="OpenStreetMap">
      <TileLayer
        attribution={OSM_ATTRIBUTION}
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        maxZoom={maxZoom}
        maxNativeZoom={19}
      />
    </LayersControl.BaseLayer>
    <LayersControl.BaseLayer name="Light">
      <TileLayer
        attribution={`${OSM_ATTRIBUTION}, &copy; <a href="https://carto.com/">CARTO</a>`}
        url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png"
        maxZoom={maxZoom}
        maxNativeZoom={20}
      />
    </LayersControl.BaseLayer>
    <LayersControl.BaseLayer name="Topographic">
      <TileLayer
        attribution={`${OSM_ATTRIBUTION}, &copy; <a href="https://opentopomap.org/">OpenTopoMap</a>`}
        url="https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png"
        maxZoom={maxZoom}
        maxNativeZoom={17}
      />
    </LayersControl.BaseLayer>
    <LayersControl.BaseLayer name="Satellite">
      <TileLayer
        attribution="Tiles &copy; Esri"
        url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
        maxZoom={maxZoom}
        maxNativeZoom={19}
      />
    </LayersControl.BaseLayer>
  </LayersControl>
);
